// Keep the purchase status in sync with the selected Shopify variant.
(function () {
  function bind(root) {
    root.querySelectorAll('.noir-stock-line:not([data-stock-bound])').forEach(function (line) {
      line.dataset.stockBound = 'true';
      var form = line.closest('.js-product');
      if (!form) return;
      form.addEventListener('on:variant:change', function (event) {
        line.hidden = !(event.detail && event.detail.variant && event.detail.variant.available);
      });
    });
  }
  bind(document);
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
